export default {
  props: {
    addenda: Array,
  },
};
